<template>
  <div :style="style"></div>
</template>

<script lang="ts" setup>
import useSystemStore from '~~/store/system'

const props = defineProps({
  backgroundColor: {
    type: String,
    default: () => 'rgba(255, 255, 255, 0)',
  },
})

const systemStore = useSystemStore()
const style = computed(() => ({
  width: '100%',
  height: `${systemStore.info.bottomSafeH || 0}px`,
  'background-color': props.backgroundColor,
}))
</script>
